// extracted by mini-css-extract-plugin
export default {"dataPoint":"+901J___DataPoint-module__dataPoint","dataPointLabel":"ttiSn___DataPoint-module__dataPointLabel","dataPointValue":"zXK8b___DataPoint-module__dataPointValue"};